export function getFileNames (state) {
  const names = []
  for (const file of state.files) {
    names.push(file.name)
  }

  return names
}
